module.exports = __webpack_public_path__ + "assets/f02c8dea4f8b8d146ea4b220a8a2b65e.jpg";